<template>
  <div class="project-category-items">
    <draggable :list="array" :disabled="disabled">
      <el-form :ref="'form-' + index"
               :model="value"
               :disabled="disabled"
               v-for="(value, index) of array"
               :key="index"
               class="array-item"
               :rules="formRules"
               size="medium"
               :inline="true">
        <slot v-bind:value="value" v-bind:index="index"></slot>
        <el-button icon="el-icon-delete-solid"
                   type="danger"
                   plain
                   @click="array.splice(index, 1)">
        </el-button>
      </el-form>
    </draggable>
    <el-button type="primary"
               plain
               size="mini"
               v-if="!disabled"
               :disabled="disabled || array.length === maxSize"
               @click="appendItem">添加
      <span v-if="array.length === maxSize">数量已达到上限</span>
    </el-button>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'SjFormSubsets',
  components: {
    draggable
  },
  props: {
    value: Array,
    defaultValue: {
      type: Function,
      default: () => null
    },
    maxSize: {
      type: Number,
      default: 100
    },
    formRules: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    array: {
      get () {
        return this.value
      },
      set () {
        this.onChanged()
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    onChanged () {
      this.$emit('input', this.array)
      this.$parent.$emit('el.form.blur')
    },
    appendItem () {
      this.array.push(this.defaultValue())
      this.$nextTick(() => {
        // 将生成的form-item组件传递回去
        this.$emit('appended', this.$refs['form-' + (this.array.length - 1)][0].$children[0])
      })
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
.project-category-items {
  .el-form-item {
    margin-bottom: 22px;
  }
  .array-item {
    transform: scale(0.9);
    .el-form-item__label {
      cursor: move
    }
  }
}
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/occupation-questionnaire/components/SjFormSubsets.vue